import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'

import CloseThin from 'ui-component-library/icons/close-thin-red.svg'

import HeadlineOne from '../Headlines/HeadlineOne'
import Modal from '../Modal'
import style from './style.scss'

type Props = {
  children: React.ReactNode
  className?: string
  closeLabelText?: string
  onClose: () => void
  titleText: string
}

Popup.defaultProps = {
  className: '',
  closeLabelText: 'close',
}

function Popup(props: Props) {
  const { className, closeLabelText, titleText, onClose, children } = props
  const closeButtonRef = useRef<HTMLButtonElement | null>(null)

  useEffect(() => {
    if (closeButtonRef.current) {
      closeButtonRef.current.focus()
    }
  }, [closeButtonRef])

  return (
    <Modal>
      <div className={classNames(style.wrapper, className)}>
        <header className={style.header}>
          <button
            ref={closeButtonRef}
            className={style.closeButton}
            data-testid='modal-close'
            onClick={onClose}
          >
            <CloseThin className={style.closeIcon} />
            <span className={style.hideLinkText}>{closeLabelText}</span>
          </button>
          <HeadlineOne>{titleText}</HeadlineOne>
        </header>
        <div className={style.body}>{children}</div>
      </div>
    </Modal>
  )
}

export default Popup
